import OffersSpecialLotusList from './OffersSpecialLotusList'

export default OffersSpecialLotusList